// extracted by css-extract-rspack-plugin
export default {"blueTable":"src-app-pages-human-staff-Monthly-Monthly-module__blueTable-C68xw4","head":"src-app-pages-human-staff-Monthly-Monthly-module__head-CewKkE","head3":"src-app-pages-human-staff-Monthly-Monthly-module__head3-qS67Yd","head4":"src-app-pages-human-staff-Monthly-Monthly-module__head4-qVCBmd","head2":"src-app-pages-human-staff-Monthly-Monthly-module__head2-k2bTph","highlight":"src-app-pages-human-staff-Monthly-Monthly-module__highlight-hnWGpN","links":"src-app-pages-human-staff-Monthly-Monthly-module__links-aA8Z_c"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"blueTable\":\"src-app-pages-human-staff-Monthly-Monthly-module__blueTable-C68xw4\",\"head\":\"src-app-pages-human-staff-Monthly-Monthly-module__head-CewKkE\",\"head3\":\"src-app-pages-human-staff-Monthly-Monthly-module__head3-qS67Yd\",\"head4\":\"src-app-pages-human-staff-Monthly-Monthly-module__head4-qVCBmd\",\"head2\":\"src-app-pages-human-staff-Monthly-Monthly-module__head2-k2bTph\",\"highlight\":\"src-app-pages-human-staff-Monthly-Monthly-module__highlight-hnWGpN\",\"links\":\"src-app-pages-human-staff-Monthly-Monthly-module__links-aA8Z_c\"}";
        // 1789362522823
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  